(() => {
  if (!/Android/i.test(navigator.userAgent)) return;

  const OPEN_CLASS = "fh-submenu-open";
  const SUMMARY_SEL = '.menu-drawer summary[aria-controls="link-filament"]';

  function forceOpen(details) {
    // Do it multiple ways + future ticks so we win the race
    const apply = () => {
      details.open = true;
      details.setAttribute("open", "");
      details.classList.add(OPEN_CLASS);
      const summary = details.querySelector("summary");
      if (summary) summary.setAttribute("aria-expanded", "true");
    };

    apply();
    setTimeout(apply, 0);
    requestAnimationFrame(apply);
    setTimeout(apply, 50);
  }

  function handler(e) {
    const summary = e.target?.closest?.(SUMMARY_SEL);
    if (!summary) return;

    const details = summary.closest("details");
    if (!details) return;

    // Block Dawn's toggle
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

    forceOpen(details);
  }

  // Capture-phase so we run before Dawn
  document.addEventListener("touchstart", handler, { capture: true, passive: false });
  document.addEventListener("pointerdown", handler, true);
  document.addEventListener("click", handler, true);

  window.__FH_ANDROID_MENU_FIX__ = "filament-v5";
})();
